"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var date_from_json_1 = require("./date-from-json");
var DateToInput = function (value) {
    if (!value) {
        return null;
    }
    try {
        return date_from_json_1.DateFromJson(value).toISOString().substring(0, 10);
    }
    catch (_) {
        return null;
    }
};
exports.DateToInput = DateToInput;
//# sourceMappingURL=date-to-input.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/skiliko-sdk/lib/helpers/date-to-input.js
// module id = 869
// module chunks = 3